export default __webpack_public_path__ + "static/media/facebook.276b4ca6.svg";